import { FC } from 'react';
import { Button } from '@doda/io-react/common';
import styles from './index.module.scss';
import { ACCORDION_ITEMS } from '../../constants';

/**
 * EmptyDisplay コンポーネントのプロパティ
 */
interface Props {
  /** 表示するラベル */
  label: string;
  /** ボタンがクリックされたときのハンドラー */
  onClick: () => void;
}

/**
 * EmptyDisplay コンポーネント
 * @param {Props} props - EmptyDisplay コンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const EmptyDisplay: FC<Props> = ({ label, onClick }) => {
  /**
   * テキスト生成関数
   * @returns {string} 生成されたテキスト
   */
  const generateText = (): string => {
    if (label === ACCORDION_ITEMS.bookmarkList.label) {
      return `保存した${label}はありません`;
    }
    return `${label}はありません`;
  };

  return (
    <div className={styles.emptyDisplay}>
      <div className={styles.emptyDisplay__inner}>
        <p>{generateText()}</p>
        <Button as="button" onClick={onClick} size="S" variant="outline_gray">
          閉じる
        </Button>
      </div>
    </div>
  );
};
